/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const monitoringIntegrationCommandResponseOutputIntegrationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationCommandResponseOutputIntegrationTeamIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationCommandResponseOutputIntegrationDefaultCustomerIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const monitoringIntegrationCommandResponseOutputIntegrationPriorityPolicyOnePriorityMax = 4;

export const monitoringIntegrationCommandResponseOutputIntegrationPriorityPolicyTwoDefaultPriorityMax = 4;

export const monitoringIntegrationCommandResponseOutputIntegrationVersionExclusiveMin = 0;
export const monitoringIntegrationCommandResponseOutputIntegrationVersionMax = 9007199254740991;

export const monitoringIntegrationCommandResponseOutputIntegrationEndpointMax = 2000;

export const monitoringIntegrationCommandResponseOutputCredentialRegExp = new RegExp(
  '^[A-Za-z0-9_-]{43}$',
);

export const MonitoringIntegrationCommandResponseOutput = zod.object({
  integration: zod.object({
    id: zod.uuid().regex(monitoringIntegrationCommandResponseOutputIntegrationIdRegExp),
    name: zod.string(),
    provider: zod.enum(['checkly', 'datadog', 'grafana', 'prtg']),
    state: zod.enum(['disabled', 'enabled', 'retired']),
    teamId: zod.union([
      zod.uuid().regex(monitoringIntegrationCommandResponseOutputIntegrationTeamIdOneRegExp),
      zod.null(),
    ]),
    defaultCustomerId: zod.union([
      zod
        .uuid()
        .regex(monitoringIntegrationCommandResponseOutputIntegrationDefaultCustomerIdOneRegExp),
      zod.null(),
    ]),
    priorityPolicy: zod.union([
      zod.object({
        mode: zod.literal('fixed'),
        priority: zod
          .int()
          .min(1)
          .max(monitoringIntegrationCommandResponseOutputIntegrationPriorityPolicyOnePriorityMax),
      }),
      zod.object({
        mode: zod.literal('payload'),
        field: zod.string().nullable(),
        defaultPriority: zod
          .int()
          .min(1)
          .max(
            monitoringIntegrationCommandResponseOutputIntegrationPriorityPolicyTwoDefaultPriorityMax,
          ),
      }),
    ]),
    credentialLabel: zod.union([zod.string().min(1), zod.null()]),
    version: zod
      .int()
      .gt(monitoringIntegrationCommandResponseOutputIntegrationVersionExclusiveMin)
      .max(monitoringIntegrationCommandResponseOutputIntegrationVersionMax),
    endpoint: zod.url().max(monitoringIntegrationCommandResponseOutputIntegrationEndpointMax),
  }),
  credential: zod
    .string()
    .regex(monitoringIntegrationCommandResponseOutputCredentialRegExp)
    .optional(),
});

export type MonitoringIntegrationCommandResponseOutput = zod.input<
  typeof MonitoringIntegrationCommandResponseOutput
>;
export type MonitoringIntegrationCommandResponseOutputOutput = zod.output<
  typeof MonitoringIntegrationCommandResponseOutput
>;
